<iframe class="kibana-iframe" [src]="kibanaUrl | safeResourceUrl"></iframe>
